import _find from "lodash/find";
import store from "@/store";

/**
 * Get "Wet stamp" details.
 *
 * @returns {*}
 */
export function wetStamp() {
  const types = store.state.providers.projectAddons.addons;

  return _find(types, item => item.name === "Wet Stamp");
}

/**
 * Get "Wet stamp 1 - 4" details.
 *
 * @returns {*}
 */
export function wetStampOneToFour() {
  const types = store.state.providers.projectAddons.addons;

  return _find(types, item => item.name === "Wet Stamp - 1 to 4");
}

/**
 * Get "Wet Stamp - 5 to 8" details.
 *
 * @returns {*}
 */
export function wetStampFiveToEight() {
  const types = store.state.providers.projectAddons.addons;

  return _find(types, item => item.name === "Wet Stamp - 5 to 8");
}

export function pzseExpress() {
  const types = store.state.providers.projectAddons.addons;

  return _find(types, item => item.name === "PZSE Express");
}

export function pzseExpressRestamp() {
  const types = store.state.providers.projectAddons.addons;

  return _find(types, item => item.name === "PZSE Express Restamp");
}

export function pzseValueEngineering() {
  const types = store.state.providers.projectAddons.addons;

  return _find(types, item => item.name === "PZSE Value Engineering");
}

export function pzsePostalInstall() {
  const types = store.state.providers.projectAddons.addons;

  return _find(types, item => item.name === "Post-Install Letter");
}

export function pzsePostalInstallRestamp() {
  const types = store.state.providers.projectAddons.addons;

  return _find(types, item => item.name === "Post-Install Letter - Restamp");
}

export function pzsePostalInstallElectrical() {
  const types = store.state.providers.projectAddons.addons;

  return _find(types, item => item.name === "Post-Install Letter (Electrical)");
}

export function pzsePostalInstallElectricalRestamp() {
  const types = store.state.providers.projectAddons.addons;

  return _find(
    types,
    item => item.name === "Post-Install Letter (Electrical) - Restamp"
  );
}

export function pzseAdditionalRestamp() {
  const types = store.state.providers.projectAddons.addons;

  return _find(types, item => item.name === "Additional Re-stamp");
}

export function pzsePlansetRedesign() {
  const types = store.state.providers.projectAddons.addons;

  return _find(types, item => item.name === "Planset Redesign");
}

export function pzseLoadCalculations() {
  const types = store.state.providers.projectAddons.addons;

  return _find(types, item => item.name === "Load Calculations");
}

export function pzseEnergyConsumptionReport() {
  const types = store.state.providers.projectAddons.addons;

  return _find(types, item => item.name === "Energy Consumption Report");
}

export function pzseResidentialPermitPlanset() {
  const types = store.state.providers.projectAddons.addons;

  return _find(types, item => item.name === "Residential Permit Planset");
}

export function pzseBatteryEnergyStorage() {
  const types = store.state.providers.projectAddons.addons;

  return _find(types, item => item.name === "Battery Energy Storage");
}

export function pzseElectricalVehicle() {
  const types = store.state.providers.projectAddons.addons;

  return _find(types, item => item.name === "Electrical Vehicle");
}

export function pzseConsumptionReportCreate() {
  const types = store.state.providers.projectAddons.addons;

  return _find(types, item => item.name === "Consumption Report Create");
}

export function pzseConsumptionReportReview() {
  const types = store.state.providers.projectAddons.addons;

  return _find(types, item => item.name === "Consumption Report Review");
}

export function pzseBatteryEnergyStorageStructural() {
  const types = store.state.providers.projectAddons.addons;

  return _find(
    types,
    item => item.name === "Battery Energy Storage (Structural)"
  );
}
